import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import moment from 'moment'
import { clone, findIndex, propEq } from 'ramda'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

import BalanceActions, { BalanceRedux, BalanceTypes } from '../Redux/BalanceRedux'
import UnvalidatedReceiptsActions from '../Redux/UnvalidatedReceiptsRedux'

const balanceCRUDObservable = createCRUDObservable({
  mainRedux: BalanceRedux,
  reduxPath: 'balance',
})

const createChargeEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.createChargeRequest)
    .mergeMap(({ studentId, charges }) => (
      Observable
        .fromPromise(Api.balance.createCharge(studentId, charges)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.createChargeError(response.error),
            ]
          }

          const balance = clone(store.getState().balance.get.results.data)
          const page = clone(store.getState().balance.get.results.meta.current_page)
          balance.transactions.unshift(charges)

          return [
            BalanceActions.getMoreRequest({studentId,page}),
            BalanceActions.createChargeSuccess(),
            notificationSuccess('Cargo Exitoso'),
          ]
        })
    ))
)

const deleteChargeEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.deleteChargeRequest)
    .mergeMap(({ chargeId }) => (
      Observable
        .fromPromise(Api.balance.deleteCharge(chargeId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.deleteChargeError(response.error),
            ]
          }

          const newBalance = clone(store.getState().balance.get.results.data)
          const chargeIndex = findIndex(propEq('id', chargeId))(newBalance.transactions)

          newBalance.transactions[chargeIndex].deleted_at = moment().format('YYYY-MM-DD HH:mm:ss')
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.deleteChargeSuccess(),
            BalanceActions.getMoreRequest({studentId,page}),
            notificationSuccess('Cargo Borrado Exitosamente'),
          ]
        })
    ))
)

const chargeChargeEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.changeChargeRequest)
    .mergeMap(({ chargeId }) => (
      Observable
        .fromPromise(Api.balance.changeCharge(chargeId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.changeChargeError(response.error),
            ]
          }

          // const newBalance = clone(store.getState().balance.get.results.data)
          // const chargeIndex = findIndex(propEq('id', chargeId))(newBalance.transactions)

          // newBalance.transactions[chargeIndex].deleted_at = moment().format('YYYY-MM-DD HH:mm:ss')
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.changeChargeSuccess(),
            BalanceActions.getMoreRequest({studentId,page}),
            notificationSuccess('Cargo Actualizado Exitosamente'),
          ]
        })
    ))
)

const deletePaymentEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.deletePaymentRequest)
    .mergeMap(({ paymentId }) => (
      Observable
        .fromPromise(Api.balance.deletePayment(paymentId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.deletePaymentError(response.error),
              notificationFail(response.error),
            ]
          }

          const newBalance = clone(store.getState().balance.get.results.data)
          const chargeIndex = findIndex(propEq('id', paymentId))(newBalance.transactions)

          newBalance.transactions[chargeIndex].deleted_at = moment().format('YYYY-MM-DD HH:mm:ss')
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.deletePaymentSuccess(),
            BalanceActions.getMoreRequest({studentId,page}),
            notificationSuccess('Pago Borrado Exitosamente'),
          ]
        })
    ))
)

const createDiscountEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.createDiscountRequest)
    .mergeMap(({ chargeId, data }) => (
      Observable
        .fromPromise(Api.balance.createDiscount(chargeId, data)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.createDiscountError(response.error),
            ]
          }
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.getMoreRequest({studentId,page}),
            //show
            BalanceActions.createDiscountSuccess(response),
            notificationSuccess('Descuento Creado'),
          ]
        })
    ))
)

const adjustDiscountEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.adjustDiscountRequest)
    .mergeMap(({ chargeId, data }) => (
      Observable
        .fromPromise(Api.balance.adjustDiscount(chargeId, data)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.adjustDiscountError(response.error),
            ]
          }
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.getMoreRequest({studentId,page}),
            //show
            BalanceActions.adjustDiscountSuccess(response),
            notificationSuccess('Descuento Creado'),
          ]
        })
    ))
)

const adjustTransactionEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.adjustTransactionRequest)
    .mergeMap(({ receiptId, data }) => (
      Observable
        .fromPromise(Api.balance.adjustTransaction(receiptId, data)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.adjustTransactionError(response.error),
            ]
          }

          return [
            UnvalidatedReceiptsActions.getRequest(),
            BalanceActions.adjustTransactionSuccess(response),
            notificationSuccess('Ajuste Creado'),
          ]
        })
    ))
)

const createPaymentEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.createPaymentRequest)
    .mergeMap(({ studentId, payment }) => (
      Observable
        .fromPromise(Api.balance.createPayment(studentId, payment)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.createPaymentError(response.error),
            ]
          }

          const pay = {
            quantity: 1,
            type: 'Payment',
          }

          if (payment instanceof FormData) {
            pay.total = payment.get('total')
            pay.registered_at = payment.get('date')
            pay.description = 'Depósito a Cuenta'
          } else {
            pay.total = payment.total
            pay.unit_price = payment.total
            pay.description = payment.description
            pay.registered_at = payment.date
          }
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
            BalanceActions.getMoreRequest({studentId,page}),
            //show
            BalanceActions.createPaymentSuccess(pay),
            notificationSuccess('Pago Exitoso'),
          ]
        })
    ))
)

const createReceiptsEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.createReceiptRequest)
    .mergeMap(({ studentId }) => (
      Observable
        .fromPromise(Api.balance.createReceipt(studentId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          const { data } = response.data
          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.createReceiptError(response.error),
              notificationFail(response.error),
            ]
          }

          return [
            BalanceActions.createReceiptSuccess(data),
            BalanceActions.getUnvalidatedReceiptsRequest(studentId),
            notificationSuccess('Recibo Creado Exitosamente'),
          ]
        })
    ))
)

const getUnvalidatedReceiptsEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.getUnvalidatedReceiptsRequest)
    .mergeMap(({ studentId }) => (
      Observable
        .fromPromise(Api.chargesToReceipts.get(studentId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.getUnvalidatedReceiptsError(response.error),
            ]
          }

          return [
            BalanceActions.getUnvalidatedReceiptsSuccess(response.data.data),
          ]
        })
    ))
)
const getValidatedReceiptsEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.getValidatedReceiptsRequest)
    .mergeMap(({ studentId , query }) => (
      Observable
        .fromPromise(Api.chargesToReceipts.getStudentValidatedReceipts(studentId,query)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.getValidatedReceiptsError(response.error),
            ]
          }

          return [
            BalanceActions.getValidatedReceiptsSuccess(response.data),
          ]
        })
    ))
)

const linkChargeToReceiptEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.linkChargeToReceiptRequest)
    .mergeMap(({ chargeId, receiptId }) => (
      Observable
        .fromPromise(Api.chargesToReceipts.link(chargeId, receiptId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.linkChargeToReceiptError(response.error),
            ]
          }
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)

          return [
            BalanceActions.getMoreRequest({studentId,page}),
            BalanceActions.linkChargeToReceiptSuccess(response.data.data),
            notificationSuccess('Cargo vinculado'),
          ]
        })
    ))
)

const unlinkChargeToReceiptEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.unlinkChargeToReceiptRequest)
    .mergeMap(({ chargeId, receiptId }) => (
      Observable
        .fromPromise(Api.chargesToReceipts.unlink(chargeId, receiptId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              BalanceActions.unlinkChargeToReceiptError(response.error),
            ]
          }
          const page = clone(store.getState().balance.get.results.meta.current_page)
          const studentId = clone(store.getState().balance.get.results.data.student_id)
          return [
             BalanceActions.unlinkChargeToReceiptSuccess(response.data.data),
              BalanceActions.getMoreRequest({studentId,page}),
            notificationSuccess('Cargo desvinculado'),
          ]
        })
    ))
)
const getMoreBalanceEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.getMoreRequest)
    .mergeMap(({ params }) => (
      Api.balance.getMoreBalance(params)
        .then(response => BalanceActions.getMoreSuccess(response.data))
        .catch(err => BalanceActions.getMoreError(err))
    ))
)
export const balanceObservers = Object.assign({}, balanceCRUDObservable.observers, {})

export const balanceEpic = combineEpics(
  balanceCRUDObservable.epic,
  createChargeEpic,
  deleteChargeEpic,
  chargeChargeEpic,
  deletePaymentEpic,
  createPaymentEpic,
  createDiscountEpic,
  adjustDiscountEpic,
  adjustTransactionEpic,
  createReceiptsEpic,
  getUnvalidatedReceiptsEpic,
  getValidatedReceiptsEpic,
  linkChargeToReceiptEpic,
  unlinkChargeToReceiptEpic,
  getMoreBalanceEpic
)



// WEBPACK FOOTER //
// ./src/Data/Observables/BalanceObservable.js